import { z } from 'zod';
import {
  PAGINATION_PAGE_SIZE_DEFAULT,
  PAGINATION_SORT_DIRECTION,
} from '~/constants';

import { PRODUCT_PRICES_SORT_BY } from './constants';

export const zodProductPricesQueryParamsSchema = z.object({
  limit: z.number().gte(1).optional().default(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().gte(0).optional().default(0),
  productId: z
    .union([z.uuid(), z.literal('new')])
    .optional()
    .catch(undefined),
  search: z.string().trim().nullish().default(''),
  sortBy: z
    .enum(PRODUCT_PRICES_SORT_BY)
    .optional()
    .default('created_on')
    .catch('created_on'),
  sortOrder: z
    .enum(PAGINATION_SORT_DIRECTION)
    .optional()
    .default('DESC')
    .catch('DESC'),
});
